import React from "react";
import { Grid } from "@mui/material";
import { useSelector } from "react-redux";
import MediaQuery from "react-responsive";

import { ContentWithHeading, DonorCard } from "../../../components";
import useStyles from "./styles/TeamSectionStyles";

export function TeamSection() {
    const classes = useStyles();
    const pageDetails = useSelector(state => state.fundraiser_page.fundraiser_details);

    return <React.Fragment>

        {/* Desktop View */}
        <MediaQuery minDeviceWidth={991}>
            <ContentWithHeading heading={`Fundraising team (${pageDetails.team_members.length})`}>
                <Grid container>
                    {
                        pageDetails.team_members && pageDetails.team_members.map(member => {
                            return <Grid item xs={6} sx={{ boxShadow: 'none !important' }} key={member.id}>
                                <DonorCard
                                    isTeamDonor={true}
                                    data={member}
                                    pageDetails={pageDetails}
                                />
                            </Grid>
                        })
                    }
                </Grid>
            </ContentWithHeading>
        </MediaQuery>

        {/* Mobile View */}
        <MediaQuery maxDeviceWidth={991}>
            <ContentWithHeading _className={classes.consistentPadding} heading={`Fundraising team (${pageDetails.team_members.length})`}>
                <Grid container>
                    {
                        pageDetails.team_members && pageDetails.team_members.map(member => {
                            return <Grid item xs={12} sx={{ boxShadow: 'none !important' }} key={member.id}>
                                <DonorCard
                                    isTeamDonor={true}
                                    data={member}
                                    pageDetails={pageDetails}
                                />
                            </Grid>
                        })
                    }
                </Grid>
            </ContentWithHeading>
        </MediaQuery>

    </React.Fragment>
}